<div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-xbig">
  <div class="cell cell-large-col-span-12 text-center">
    <h1 class="display-small text-center margin-bottom-xmedium">{{ data.settings?.heading }}</h1>
    <mat-accordion class="text-left" *ngFor="let item of data.settings?.accordionItems">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="padding-vertical-medium">
            <h3>{{ item.title }}</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p [innerHTML]="item.content"></p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>